const initialState = {
    profileloading: false,
    profileData : []
  };
  
  const profileStore = (state = initialState, action ) => {
      switch(action.type){
          case "PROFILELOADER": {
            return {...state, profileloading:action.response }
          }
          case "GET_PROFILEDATA": {
            return { ...state, profileData: action.response, profileloading:false };
          }
          case "UPDATE_PROFILEDATA":{
            return { ...state, profileData: action.response, profileloading:false};
          }
          case "PROFILEFAIL":{
            return { ...state, profileloading: action.response };
          }
          default:
            return { ...state };
    }
  }
  
  export default profileStore;